import { Enum } from "../../types/types";

export const LoginPageLocators = Enum(
  "login_button_reset_password",
  "login_button_ban_ok",
  "login__input_email_or_username",
  "login__checkbox_stay_logged_in",
  "login__input_password",
  "login__highlighted_text_forgot_password",
  "login__button_login",
  "login__button_social_auth",
  "login__highlighted_text_create_new_account",
  "link_login",
  "account_locked__page_title_locked",
  "account_locked__button_reset_password",
  "account_locked__button_close",
  "login__banner_error"
);
export type LoginPageLocators = Enum<typeof LoginPageLocators>;
